import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconHeart = props => {
  const { rootClassName, className, pencilClassName } = props;
  const classes = classNames(rootClassName || root, className);
  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4 8.1001C20.4 5.61482 18.3014 3.6001 15.7125 3.6001C13.7769 3.6001 12.1153 4.72638 11.4 6.33352C10.6847 4.72638 9.02314 3.6001 7.08752 3.6001C4.49869 3.6001 2.40002 5.61482 2.40002 8.1001C2.40002 15.3207 11.4 20.1001 11.4 20.1001C11.4 20.1001 20.4 15.3207 20.4 8.1001Z"
        stroke="#535763"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconHeart.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
};

const { string } = PropTypes;

IconHeart.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
};

export default IconHeart;
